const SUBSCRIPTION_APPS = {
  recharge: "294517",
  skio: "SKIO",
};

document.addEventListener("alpine:init", () => {
  Alpine.data("CtrProductBox", () => ({
    mode: "subscribe",
    selectedVariant: null,
    fallbackSellingPlanId: null,
    subscriptionProvider: "recharge",
    mainProduct: {},
    subscriptionDataObj: { selling_plans: [] },
    activePlanIds: new Set(),
    selectedSellingPlanId: null,
    loading: false,
    variantMediaMap: {},
    sectionId: null,
    giftVariants: [],
    giftPropertyKey: '_offer',
    giftPropertyValue: 'free-gifts',
    insuredShippingVariant: null,
    redirectAfterAdd: 'checkout',

    init() {
      this.mode = this.$el.dataset.defaultMode || "subscribe";
      this.selectedVariant = this.parseNullableInt(
        this.$el.dataset.initialVariantId
      );
      this.fallbackSellingPlanId = this.parseNullableInt(
        this.$el.dataset.fallbackSellingPlanId
      );
      this.subscriptionProvider =
        this.$el.dataset.subscriptionProvider === "skio" ? "skio" : "recharge";
      this.sectionId = this.$el.dataset.sectionId || null;
      this.giftVariants = (this.$el.dataset.giftVariants || '')
        .split(',')
        .map(v => v.trim())
        .filter(v => v !== '');
      this.giftPropertyKey = this.$el.dataset.giftPropertyKey || '_offer';
      this.giftPropertyValue = this.$el.dataset.giftPropertyValue || 'free-gifts';
      this.insuredShippingVariant = this.parseNullableInt(this.$el.dataset.insuredShippingVariant);
      this.redirectAfterAdd = this.$el.dataset.redirectAfterAdd || 'checkout';

      this.parseVariantMediaMap();
      this.parseSubscriptionProduct();
      this.loadSubscriptionPlans();
      this.setSellingPlanForVariant(this.selectedVariant);
       // Fix: reset loading state when navigating back from checkout (bfcache)
  window.addEventListener('pageshow', (event) => {
    if (event.persisted) this.loading = false;
  });
    },

    normalizePlanId(id) {
      if (id === undefined || id === null || id === "") return null;
      const parsed = Number(id);
      return Number.isFinite(parsed) ? parsed : id;
    },

    isProviderGroup(group, provider) {
      const appId = String(group?.app_id ?? "").toUpperCase();
      if (provider === "skio") {
        return appId === "SKIO" || appId.includes("SKIO");
      }
      return appId === "294517" || group?.app_id === 294517;
    },

    getActiveAppId() {
      return SUBSCRIPTION_APPS[this.subscriptionProvider] || SUBSCRIPTION_APPS.recharge;
    },

    parseNullableInt(value) {
      if (value === undefined || value === null || value === "") return null;
      const parsed = Number(value);
      return Number.isFinite(parsed) ? parsed : null;
    },

    parseSubscriptionProduct() {
      const rawJson = this.$refs.rechargeProductJson?.textContent;
      if (!rawJson) {
        this.mainProduct = {};
        return;
      }
      try {
        this.mainProduct = JSON.parse(rawJson);
      } catch (error) {
        console.error("[ctr-pb] subscription product parse error", error);
        this.mainProduct = {};
      }
    },

    loadSubscriptionPlans() {
      const provider = this.subscriptionProvider;
      const allGroups = this.mainProduct.selling_plan_groups || [];
      let groups = allGroups.filter((g) => this.isProviderGroup(g, provider));

      // Skio: if app_id is not literally "SKIO", use any non-Recharge group
      if (provider === "skio" && groups.length === 0) {
        groups = allGroups.filter(
          (g) => String(g?.app_id ?? "") !== "294517" && g?.app_id !== 294517
        );
      }

      const allPlans = groups.flatMap((g) =>
        Array.isArray(g.selling_plans) ? g.selling_plans : []
      );

      const normalized = [];
      const seen = new Set();

      for (const plan of allPlans) {
        const planId = this.normalizePlanId(plan?.id);
        if (!plan || planId == null || seen.has(planId)) continue;
        seen.add(planId);

        const adjustment = plan.price_adjustments?.[0] || {};
        normalized.push({
          id: planId,
          name: plan.name,
          discount: adjustment.value || 0,
          discount_type: adjustment.value_type || "",
          fixed_price:
            adjustment.value_type === "price" ? adjustment.value : null,
        });
      }

      this.subscriptionDataObj = { selling_plans: normalized };
      this.activePlanIds = new Set(normalized.map((plan) => plan.id));
    },

    getAllocationPlanId(allocation) {
      if (!allocation) return null;
      return this.normalizePlanId(
        allocation.selling_plan_id ?? allocation.selling_plan?.id
      );
    },

    getActiveAllocation(variant) {
      if (!variant) return null;
      const allocations = variant.selling_plan_allocations || [];

      if (this.activePlanIds.size) {
        const matched = allocations.find((allocation) => {
          const planId = this.getAllocationPlanId(allocation);
          return planId != null && this.activePlanIds.has(planId);
        });
        if (matched) return matched;
      }

      const withPlanId = allocations.find(
        (allocation) => this.getAllocationPlanId(allocation) != null
      );
      return withPlanId || allocations[0] || null;
    },

    getVariantById(variantId) {
      const normalizedVariantId = this.normalizePlanId(variantId);
      return (this.mainProduct.variants || []).find(
        (item) => this.normalizePlanId(item.id) === normalizedVariantId
      );
    },

    getVariantPlanIds(variant) {
      const ids = new Set();
      const allocations = variant?.selling_plan_allocations || [];

      allocations.forEach((allocation) => {
        const planId = this.getAllocationPlanId(allocation);
        if (planId == null) return;
        if (this.activePlanIds.size && !this.activePlanIds.has(planId)) return;
        ids.add(planId);
      });

      return ids;
    },

    getAvailableSellingPlans(variantId = this.selectedVariant) {
      const plans = this.subscriptionDataObj?.selling_plans || [];
      if (!plans.length) return [];

      const variant = this.getVariantById(variantId);
      if (!variant) return plans;

      const variantPlanIds = this.getVariantPlanIds(variant);
      if (!variantPlanIds.size) return plans;

      return plans.filter((plan) => variantPlanIds.has(plan.id));
    },

    isSellingPlanAvailableForVariant(planId, variantId = this.selectedVariant) {
      const normalizedPlanId = this.normalizePlanId(planId);
      if (normalizedPlanId == null) return false;

      return this.getAvailableSellingPlans(variantId).some(
        (plan) => plan.id === normalizedPlanId
      );
    },

    onSellingPlanChange(planId) {
      const normalizedPlanId = this.normalizePlanId(planId);
      if (this.isSellingPlanAvailableForVariant(normalizedPlanId)) {
        this.selectedSellingPlanId = normalizedPlanId;
      }
    },

    resolveSellingPlanId(variantId) {
      this.setSellingPlanForVariant(variantId, this.selectedSellingPlanId);
      return this.selectedSellingPlanId;
    },

    setSellingPlanForVariant(variantId, preferredPlanId = null) {
      const plans = this.subscriptionDataObj?.selling_plans || [];
      const normalizedPreferredPlanId = this.normalizePlanId(preferredPlanId);
      const variant = this.getVariantById(variantId);
      const allocation = this.getActiveAllocation(variant);

      if (!plans.length) {
        const allocationPlanId = this.getAllocationPlanId(allocation);
        this.selectedSellingPlanId =
          allocationPlanId ?? this.fallbackSellingPlanId;
        return;
      }

      if (
        normalizedPreferredPlanId != null &&
        this.isSellingPlanAvailableForVariant(normalizedPreferredPlanId, variantId)
      ) {
        this.selectedSellingPlanId = normalizedPreferredPlanId;
        return;
      }

      const allocationPlanId = this.getAllocationPlanId(allocation);
      const availablePlans = this.getAvailableSellingPlans(variantId);
      const matchedPlan = availablePlans.find((plan) => plan.id === allocationPlanId);

      if (matchedPlan) {
        this.selectedSellingPlanId = matchedPlan.id;
        return;
      }

      const fallbackMatched = availablePlans.find(
        (plan) => plan.id === this.fallbackSellingPlanId
      );
      this.selectedSellingPlanId = fallbackMatched
        ? fallbackMatched.id
        : availablePlans[0]?.id ?? plans[0].id;
    },

    parseVariantMediaMap() {
      const rawJson = this.$refs.variantMediaMap?.textContent;
      if (!rawJson) return;
      try {
        this.variantMediaMap = JSON.parse(rawJson);
      } catch (e) {
        this.variantMediaMap = {};
      }
    },

    slideToVariantImage(variantId) {
      if (!this.sectionId) return;
      const mediaId = this.variantMediaMap[String(variantId)];
      if (!mediaId) return;

      const mainEl = document.querySelector("#ctr-pb-main-" + this.sectionId);
      if (!mainEl || !mainEl.swiper) return;

      const slides = Array.from(mainEl.querySelectorAll(".swiper-slide"));
      const targetIndex = slides.findIndex(
        (slide) => slide.dataset.mediaId === String(mediaId)
      );

      if (targetIndex !== -1) {
        mainEl.swiper.slideTo(targetIndex);
      }
    },

    onVariantChange(variantId) {
      this.selectedVariant = variantId;
      this.setSellingPlanForVariant(variantId, this.selectedSellingPlanId);
      this.slideToVariantImage(variantId);
    },

    addToCart() {
      if (!this.selectedVariant || this.loading) return;

      this.loading = true;

      const t0 = performance.now();
      const log = (label) => console.log(`[ctr-pb] ${label}: +${Math.round(performance.now() - t0)}ms`);
      log('click');

      const mainItem = { id: this.selectedVariant, quantity: 1 };
      if (this.mode === "subscribe") {
        const sellingPlanId = this.resolveSellingPlanId(this.selectedVariant);
        if (sellingPlanId) {
          mainItem.selling_plan = sellingPlanId;
        } else {
          console.warn(
            "[ctr-pb] subscribe ATC without selling_plan",
            {
              provider: this.subscriptionProvider,
              variantId: this.selectedVariant,
              plans: this.subscriptionDataObj?.selling_plans,
            }
          );
        }
      }

      const items = [mainItem];
      if (this.mode === "subscribe") {
        const giftPropKey = this.giftPropertyKey;
        const giftPropValue = this.giftPropertyValue;
        this.giftVariants.forEach(function(variantId) {
          const props = {};
          props[giftPropKey] = giftPropValue;
          items.push({
            id: parseInt(variantId, 10),
            quantity: 1,
            properties: props
          });
        });
      }

      if (this.insuredShippingVariant) {
        items.push({
          id: this.insuredShippingVariant,
          quantity: 1,
          properties: { '_insured_shipping': 'true' }
        });
      }

      fetch("/cart/clear.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
      })
        .then(function(r) { log('clear done'); return r.json(); })
        .then(() => {
          log('add start');
          return fetch("/cart/add.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ items: items }),
          });
        })
        .then(function(r) { log('add done'); return r.json(); })
        .then(() => {
          log('redirect');
          // Fire ATC event for paid product only
          const variant = (this.mainProduct.variants || []).find(
            (v) => this.normalizePlanId(v.id) === this.normalizePlanId(this.selectedVariant)
          );
          if (variant && window.Shopify?.analytics?.publish) {
            window.Shopify.analytics.publish('custom_add_to_cart', {
              variantId: String(this.selectedVariant),
              productTitle: this.mainProduct.title || '',
              price: (variant.price / 100).toFixed(2),
              currency: window.Shopify?.currency?.active || 'USD',
              quantity: 1
            });
            console.log('[ctr-pb] ATC published for:', this.mainProduct.title);
          }

          if (this.redirectAfterAdd === 'checkout') window.location.href = '/checkout';
          else if (this.redirectAfterAdd === 'cart') window.location.href = '/cart';
          else this.loading = false;
        })
        .catch((error) => {
          console.error("[ctr-pb] cart error", error);
          this.loading = false;
        });
    },
  }));
});
window.addEventListener('pageshow', function(event) {
  if (event.persisted) {
    const section = document.getElementById('ctr-pb-template--20255796560046__ctr_product_box_7b6ezE');
    if (section) {
      const top = section.getBoundingClientRect().top + window.scrollY - 93;
      window.scrollTo({ top: top, behavior: 'instant' });
    }
  }
});
